export const rejectRentalReservationValidation = {
  comment: [{ required: true, message: 'Comment is required!' }],
};
